module.exports = __webpack_public_path__ + "static/media/add-credit-icon.e756c1e9.svg";